import React, { useState } from "react";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const InfoPopup = ({ infoText }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="info-icon-button"
        aria-label="More information"
        onClick={() => setOpen(true)}
        tabIndex={0}
      > 
        <InfoOutlinedIcon fontSize="medium" />
      </button>
      {open && (
        <div className="modal-overlay" onClick={() => setOpen(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div>
              <h3 style={{ display: 'flex', alignItems: 'center', gap: '0.5em', marginBottom: '1em', color: 'var(--primary-color)' }}>
                <InfoOutlinedIcon fontSize="large" className="modal-icon" />
                Information
              </h3>
              <div className="modal-body">
                <p>{infoText}</p>
              </div>
              <div className="buttonContainer mt-2">
                <button className="button" onClick={() => setOpen(false)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InfoPopup;
